module.exports = __webpack_public_path__ + "img/motorcycle-red.b3ae9952.svg";